const productGallery = () => {
    const selectors = {
        pswpImage: '.pswp__img',
    };
    const events = ['threadheads:photoswipe-loadComplete', 'threadheads:photoswipe-change'];
    events.forEach((event) => {
        window.addEventListener(event, () => {
            setTimeout(() => {
                const pswpImages = document.querySelectorAll(selectors.pswpImage);
                pswpImages.forEach((image) => {
                    image.setAttribute('oncontextmenu', 'return false;');
                });
            }, 5);
        });
    });
};
export { productGallery };
